import { SVGProps } from 'react';

export function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M21.5306 7.28055L9.53065 19.2806C9.46099 19.3503 9.37827 19.4056 9.28723 19.4433C9.19618 19.4811 9.09858 19.5005 9.00002 19.5005C8.90146 19.5005 8.80386 19.4811 8.71282 19.4433C8.62177 19.4056 8.53905 19.3503 8.46939 19.2806L3.2194 14.0306C3.07866 13.8898 2.9996 13.699 2.9996 13.4999C2.9996 13.3009 3.07866 13.11 3.2194 12.9693C3.36013 12.8286 3.551 12.7495 3.75002 12.7495C3.94904 12.7495 4.13991 12.8286 4.28065 12.9693L9.00002 17.6896L20.4694 6.2193C20.6101 6.07857 20.801 5.99951 21 5.99951C21.199 5.99951 21.3899 6.07857 21.5306 6.2193C21.6714 6.36003 21.7504 6.55091 21.7504 6.74993C21.7504 6.94895 21.6714 7.13982 21.5306 7.28055Z"
        fill="#10B981"
      />
    </svg>
  );
}
